














































import Vue from 'vue';
import * as documentApi from './document-api';
import { FileItem } from '../../services/common/file-service';

export default Vue.extend({
    data() {
        return {
            files: [] as FileItem[],
        };
    },
    props: {
        applicationName: {
            type: String,
            required: true,
        },
        divisionName: {
            type: String,
            required: true,
        },
        moduleName: {
            type: String,
            required: true,
        },
        folderName: {
            type: String,
            required: true,
        },
        fileName: {
            type: String,
            required: false,
        },
        fileExtension: {
            type: String,
            required: false,
        },
        accept: {
            type: String,
            required: false
        },
        multiple: {
            type: Boolean,
            required: false
        }
    },
    methods: {
        async loadFiles() {
            this.files = await documentApi.find({
                applicationName: this.applicationName,
                divisionName: this.divisionName,
                moduleName: this.moduleName,
                folderName: this.folderName,
                fileName: this.fileName,
                fileExtension: this.fileExtension,
            });
        },
        async uploadFiles(files: FileList) {
            if (files.length === 0) {
                return;
            }
            await documentApi.upload(
                {
                    applicationName: this.applicationName,
                    divisionName: this.divisionName,
                    moduleName: this.moduleName,
                    folderName: this.folderName,
                },
                files
            );
            (this.$refs.files as any).reset();
            await this.loadFiles();
        },
        downloadFile(file: FileItem) {
            documentApi.download(file.id);
        },
        async deleteFile(file: FileItem) {
            await documentApi.deleteFile(file.id);
            await this.loadFiles();
        },
    },
    async mounted() {
        await this.loadFiles();
    },
});
